module.exports = __webpack_public_path__ + "static/media/press_fl_logo.e516a3bc.jpg";